module.exports = __webpack_public_path__ + "img/turkaiLogo.0cee9a52.png";